import { useQuery } from "react-query";
import { TransactionResponse } from "../models/wallet/transactionDetails";
import AuthService from "../services/authService";
import ApiRoutes from "../services/apiRoutes";
import { formatDateHyphen } from "../utility";
import { apiDirect } from "../services/apiService";

function useTransactionApi() {
  return useQuery<TransactionResponse>(`getTransaction`, () => {
    const user = AuthService.user?.data;

    const date30DaysAgo = new Date(
      new Date().setDate(new Date().getDate() - 3000)
    );
    const params = new URLSearchParams();
    params.append("Email", user?.email || "");
    params.append("StartDate", formatDateHyphen(date30DaysAgo));
    params.append("EndDate", formatDateHyphen(new Date()));
    params.append("PageIndex", "2");
    params.append("PageTotal", "5");

    const url = `${ApiRoutes.getTransaction}?${params.toString()}`;
    apiDirect.post(url).then((data) => {
      console.log(data);
    });

    return apiDirect.post(url);
  });
}

export default useTransactionApi;
